import { memo } from 'react'
import { useWeb3Connected } from '../../../store/web3/hooks'
import { ConnectButton } from '../ConnectButton'
import { Stack, styled } from '@mui/material'
import { CurrentAddress } from './CurrentAddress'
import { MenuItem } from '../Menu/MenuItem'
import { MenuKeys } from '../Menu/atoms'
import { useLinkConnected } from 'store/link/hooks'
import { AccountModal } from '../AccountModal'

const ConnectedAccountWrap = styled(Stack)`
  margin-right: 16px;
`

export const ConnectedAccount = memo(() => {
  const web3Connected = useWeb3Connected()
  const isLinkConnected = useLinkConnected()

  if (!web3Connected) {
    return (
      <ConnectedAccountWrap id="zk_connect_button">
        <ConnectButton />
      </ConnectedAccountWrap>
    )
  }

  return (
    <MenuItem
      id="zk_connect_button"
      menuKey={MenuKeys.Account}
      hideArrow={web3Connected}
      popup={isLinkConnected ? <AccountModal /> : null}
      direction="right"
      className="nav-item"
    >
      <CurrentAddress />
    </MenuItem>
  )
})
